import { useFormy, useFormyValidator } from '@givebacks/formy';

/**
 * @deprecated use useFormyValidator instead
 */
const useFormListValidation = useFormyValidator;

/**
 * @deprecated use useFormy instead
 */
const useFormListValidator = useFormy;
export { useFormListValidation, useFormListValidator };
